<template>
  <div id="numeral-screen">
    <div v-if="size !== 0" :style="{'transform': 'scale(' + size + ')', 'transformOrigin': transform}">
      <el-col class="numeral-map">
        <common-map v-if="siteList != null" :key="siteList" :siteList="siteList" />
      </el-col>

      <el-col class="screen-top-row">
        <el-row class="screen-date-area">时间:{{new Date().Format('yyyy-MM-dd')}}</el-row>
        <el-row class="screen-title-area">综 合 能 碳 管 理 平 台</el-row>
        <el-row class="screen-btn-area">
          <el-col class="screen-change-btn" @click.native="toggleFullScreen(1)">
            {{ isFullscreen?"恢复":"全屏" }}
            <el-col v-if="isFullscreen" class="screen-return-btn-icon"></el-col>
            <el-col v-else class="screen-full-btn-icon"></el-col>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="left-col" :key="rightStamp">
        <digital-block v-for="block in blocks" :key="block.index" :block-index="block.index" :block-data="block" :source-data="brief" :isFull="true"/>
        <warning-block :is-full="true" :alarm-map="brief.alarmMap" :alarm-list="brief.alarmList"/>
      </el-col>

      <el-col class="middle-col" :key="rightStamp">
        <station-block :isFull="true" :site-num="brief.siteNum"/>
        <online-block :isFull="true" :sensor-num="[brief.onlineNum, brief.deviceNum]"/>
      </el-col>

      <el-col class="right-col" :key="rightStamp">
        <coal-block :is-full="true" :coal-data="brief2.coalData"/>
        <energy-block :is-full="true" :coal-data="brief2.strengthData"/>
      </el-col>
    </div>
  </div>
</template>

<script>
import CommonMap from "../../common/map/CommonMap";
import DigitalBlock from "../DigitalScreen/DigitalBlock";
import StationBlock from "../DigitalScreen/StationBlock";
import OnlineBlock from "../DigitalScreen/OnlineBlock";
import CoalBlock from "../DigitalScreen/CoalBlock";
import WarningBlock from "../DigitalScreen/WarningBlock";
import EnergyBlock from "../DigitalScreen/EnergyBlock";

export default {
  name: "SiteScreen2",
  components: {WarningBlock, CoalBlock, OnlineBlock, StationBlock, DigitalBlock, EnergyBlock, CommonMap},
  data() {
    return {
      isFullscreen: false,
      blocks: [
        {index: 0, typeName: '电', unit: '度', color: '#12C5C0', valueProp: ['dayEnergy', 'lastEnergy', 'energyProp', 'monEnergy'], icon: 'zy-icon-ele'},
        {index: 1, typeName: '水', unit: 'm³', color: '#027DDA', valueProp: ['dayWater', 'lastWater', 'waterProp', 'monWater'], icon: 'zy-icon-water'},
        {index: 2, typeName: '气', unit: 'm³', color: '#FB9E1E', valueProp: ['dayGas', 'lastGas', 'gasProp', 'monGas'], icon: 'zy-icon-gas'},
        {index: 3, typeName: '热', unit: 'm³', color: '#39BD67', valueProp: ['dayHeat', 'lastHeat', 'heatProp', 'monHeat'], icon: 'zy-icon-heat'}
      ],
      brief: {dayEnergy: '', lastEnergy: '', energyProp: '', monEnergy: '', dayWater: '-', lastWater: '-', waterProp: '-', monWater: '-',
        dayGas: '-', lastGas: '-', gasProp: '-', monGas: '-', dayHeat: '-', lastHeat: '-', heatProp: '-', monHeat: '-',
        runDay: '-', alarmNum: '-', siteNum: '-', commNum: '-', sensorNum: [0, 0], alarmMap: {}, coalCurve: {}, alarmList: {}
      },
      brief2: {
        coalData: {
          yearCoal: 0,
          coalLimit: 0,
          coalProp: 0,
          coalFlag: 0,
          coal1: 0,
          coal2: 0,
          coal3: 0,
          coal4: 0
        },
        strengthData: {
          dataDate1: ['能耗强度'],
          dataData1: [{name: '', label: {show: true, position: 'right', color: '#FFFFFF'}, type: 'bar', data: [0], barWidth: '30'},
            {name: '', label: {show: true, position: 'right', color: '#FFFFFF'}, type: 'bar', data: [0], barWidth: '30'}],
          dataDate2: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          dataData2: ', , , , , , , , , , , ',
          dataDate3: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          dataData3: ', , , , , , , , , , , '
        }
      },
      siteList: null,
      mapRefreshCount: 10,
      screenTimeout: null,
      rightStamp: 0,
      size: 0,
      transform: '0 0'
    }
  },
  created() {
    addEventListener("fullscreenchange", this.handleFullScreen);
    this.$nextTick(function() {
      this.toggleFullScreen(0);
    })
    this.getScreenData();
    if (this.screenTimeout === null) {
      this.screenTimeout = setInterval(() => {
        this.getScreenData();
      }, 5 * 60 * 1000);
    }
  },
  mounted() {
    const widthSize = (window.innerWidth - 181) / 1920
    const heightSize = (window.innerHeight - 49) / 1080
    if (widthSize <= heightSize) {
      this.size = widthSize
      this.transform = '0 ' + ((window.innerHeight - 49 - 1080 * widthSize) / (1 - widthSize) / 2).toFixed(0) + 'px'
    } else {
      this.size = heightSize
      this.transform = ((window.innerWidth - 181 - 1920 * heightSize) / (1 - heightSize) / 2).toFixed(0) + 'px' + ' 0'
    }
    this.toggleFullScreen(1);
  },
  beforeDestroy() {
    removeEventListener('fullscreenchange', this.handleFullScreen)
    this.brief = null;
    this.siteList = null;
    if (this.screenTimeout !== null) {
      clearInterval(this.screenTimeout)
    }
  },
  methods: {
    handleFullScreen(e) {
      if (document.fullscreenElement) {
        const widthSize = window.innerWidth / 1920
        const heightSize = window.innerHeight / 1080
        if (widthSize <= heightSize) {
          this.size = widthSize
        } else {
          this.size = heightSize
        }
        if(!this.isFullscreen) {
          this.isFullscreen = true;
        }
      } else {
        // const widthSize = (window.innerWidth - 181) / 1920
        // const heightSize = (window.innerHeight - 49) / 1080
        // if (widthSize <= heightSize) {
        //   this.size = widthSize
        //   this.transform = '0 ' + ((window.innerHeight - 49 - 1080 * widthSize) / (1 - widthSize) / 2).toFixed(0) + 'px'
        // } else {
        //   this.size = heightSize
        //   this.transform = ((window.innerWidth - 181 - 1920 * heightSize) / (1 - heightSize) / 2).toFixed(0) + 'px' + ' 0'
        // }
        // if(this.isFullscreen) {
        //   this.isFullscreen = false;
        // }
        this.$emit('reloadPage')
      }
    },
    getScreenData() {
      if(this.mapRefreshCount >= 10) {
        this.$api.energyDisplay.getSiteList().then(res => {
          this.siteList = res.data;
        })
        this.mapRefreshCount = 0;
      }
      this.mapRefreshCount++;
      this.$api.energyDisplay.getDigitalScreenData1().then(res => {
        this.brief = res.data;
      });
      this.$api.energyDisplay.getDigitalScreenData2().then(res => {
        this.brief2.coalData = res.data.coalData;
        this.brief2.strengthData.dataData1[0].name = res.data.strengthData.nowYear;
        this.brief2.strengthData.dataData1[0].data[0] = res.data.strengthData.nowStrength;
        this.brief2.strengthData.dataData1[1].name = res.data.strengthData.lastYear;
        this.brief2.strengthData.dataData1[1].data[0] = res.data.strengthData.lastStrength;
        this.brief2.strengthData.dataData2 = res.data.strengthData.dataData2;
        this.brief2.strengthData.dataData3 = res.data.strengthData.dataData3;
        this.rightStamp = new Date().getTime();
      });
    },
    FullScreen(el) {
      this.size = 0
      this.transform = '0 0'
      if(!this.isFullscreen) { // 进入全屏
        if(el.requestFullscreen) {
          el.requestFullscreen()
        }else if(el.mozRequestFullScreen) {
          el.mozRequestFullScreen()
        }else if(el.webkitRequestFullscreen) {
          // 改变平面图在google浏览器上面的样式问题
          $("#numeral-screen").css("position", "absolute").css("width", "94%");
          $(".buildingsFloor").css("width", "98%");
          $(".floor-plan").css("width", "90%");
          el.webkitRequestFullscreen();
        }else if(el.msRequestFullscreen) {
          el.msRequestFullscreen()
        }
      }else { // 退出全屏
        if(document.exitFullscreen) {
          console.log(111)
          document.exitFullscreen()
        }else if(document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        }else if(document.webkitExitFullscreen) {
          // 改变平面图在google浏览器上面的样式问题
          $("#numeral-screen").css("position", "static").css("width", "100%");
          $(".buildingsFloor").css("width", "70%");
          $(".floor-plan").css("width", "78%");
          document.webkitExitFullscreen()
        }else if(!document.msRequestFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
    toggleFullScreen(e) {
      if (e === 1) {
        console.log('toggleScreen')
        let el = document.getElementById('numeral-screen');
        // let el=e.srcElement||e.target;//target兼容Firefox
        this.FullScreen(el);
      }
    }
  }
}
</script>

<style scoped>
  #numeral-screen{
    width: 100%;
    height: 100%;
    background-color: #1F1F1F;
    overflow: hidden;
  }
  .numeral-map{
    position: absolute;
    top: 0;
    left: 0;
    height: 1080px;
    width: 1920px;
  }
  .left-col{
    position: absolute;
    top: 66px;
    left: 0;
    width: 598px;
    height: 997px;
    display: flex;
    flex-wrap: wrap;
  }
  .middle-col{
    position: absolute;
    top: 830px;
    left: 633px;
    width: 650px;
    height: 233px;
    color: #FFFFFF;
  }
  .right-col{
    position: absolute;
    top: 66px;
    left: 1316px;
    width: 587px;
    height: 997px;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SiteScreen/SiteScreen2.vue